// import { BasicLayout, BlankLayout } from '@/components/layouts';

import wenjuanList from '@/router/modules/wenjuan/list';
import wenjuanDetail from '@/router/modules/wenjuan/detail';
import schemeIndex from '@/router/modules/scheme/index';
import schemeEdit from '@/router/modules/scheme/edit';
import shenbi from '@/router/modules/shenbi/trial';
import shiyong from '@/router/modules/shenbi/shiyong';
export default [
  wenjuanList,
  wenjuanDetail,
  schemeIndex,
  schemeEdit,
  shenbi,
  shiyong,
  {
    path: '*',
    redirect: '/404',
    hiddenInMenu: true,
  },
];
